<template>
  <div>

      <h5>レビュー一覧</h5>
      <hr>
      <div class="text-left my-2">
        <span v-if="String(type) == ''" class="">すべて</span>
        <a style="color: #4170ff!important;" @click="changeType('')" class=""  v-else>すべて</a>
        <span class="px-2">/</span>
        <span v-if="String(type) == '2'" class="">販売者</span>
        <a style="color: #4170ff!important;" @click="changeType(2)" class=""  v-else>販売者</a>
        <span class="px-2">/</span>
        <span v-if="String(type) == '1'" class="">ピアノ</span>
        <a style="color: #4170ff!important;" @click="changeType(1)" class=""  v-else>ピアノ</a>
      </div>

      <div class="text-right my-2">
        <span v-if="String(sort) == '1'" class="">投稿日順</span>
        <a style="color: #4170ff!important;" @click="changeSort(1)" class=""  v-else>投稿日順</a>
        <span class="px-2">/</span>
        <span v-if="String(sort) == '2'" class="">満足度順</span>
        <a style="color: #4170ff!important;" @click="changeSort(2)" class=""  v-else>満足度順</a>
      </div>

      <div class="py-3 contents">
          <div v-for="(review, index) in allGetReviews">
            <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-header">
                  <div class="row">
                      <div class="col-md-8 text-left d-flex">
                        <span class="mr-2">{{ get_hash_value(brand, review['brand']) }} {{ review['model_number'] }}</span>
                        <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="review['evaluation']"></star-rating>
                      </div>
                      <span class="col-md-4 text-right">
                        {{ date_only_format(review['review']['created_at']) }}
                      </span>
                  </div>
              </div>
              <div class="card-body row p-2 m-0">
                <div class="col-md-3 p-2 m-0" style="flex-flow: column;display: flex;align-items: center;justify-content: center;">
                  <img class="" :src="review['image1']" style="width: 80%;height: auto;">
                  <p>{{ get_hash_value(gender, review['gender']) }}</p>
                  <p>{{ review['nickname'] }}</p>
                </div>
                <div class="card col-md-9 pl-0 pr-0 m-0" style="position: relative;">
                  <div class="card-body">
                    <p class="card-text mb-3" style="min-height: 140px;">
                      <span class="">{{ review['review']['contents'] }}</span>
                    </p>
                    <template v-if="String(review['review']['type']) == '2' && review['review_comment_comp']"> <!-- 販売者 返答済み -->
                      <button @click="showModalDetail(review)" style="position: absolute;bottom: 10px;right: 20px;width: 160px;" class="btn btn-primary">レビュー詳細</button>
                    </template>
                    <template v-else-if="String(review['review']['type']) == '2'"> <!-- 販売者 -->
                      <button @click="showModalDetail(review)" style="position: absolute;bottom: 50px;right: 20px;width: 160px;" class="btn btn-primary">レビュー詳細</button>
                      <button @click="modalReviewComment(review['review']['id'])" style="position: absolute;bottom: 10px;right: 20px;width: 160px;color: red;background-color: white!important;border: solid 1px red!important;" class="btn btn-primary">返答する</button>
                    </template>
                    <template v-else-if="String(review['review']['type']) == '1'"> <!-- ピアノ -->
                      <button @click="showModalDetail(review)" style="position: absolute;bottom: 10px;right: 20px;width: 160px;" class="btn btn-primary">レビュー詳細</button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page" v-show="all_reviews.length>0">
            <vuejs-paginate
              :page-count="allGetPageCountReview"
              :page-range="3"
              :margin-pages="2"
              :click-handler="allClickCallbackReview"
              :prev-text="'＜'"
              :next-text="'＞'"
              :container-class="'pagination'"
              :page-class="'page-item'">
            </vuejs-paginate>
          </div>
      </div>

      <div id="overlay" class="review_comment" v-show="displayReviewCommentModal">
        <b-container>
          <div class="review_comment_modal card text-left m-auto" style="overflow: hidden;">
            <div class="card-header text-left" style="background-color: #fff;">
              <span>レビューの返答</span>
            </div>
            <div class="text-center mx-3 mt-3">
              <textarea placeholder="" v-model="reviewCommentForm.contents" class="w-100" rows="6"></textarea>
            </div>
            <b-row class="mb-3">
              <b-col class="text-right px-4">
                <button id="review_comment_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="post_review_comment">返答する</button>
                <button id="review_comment_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="displayReviewCommentModal=false">閉じる</button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>

      <div id="overlay" class="detail" v-show="displayDetailModal">
        <b-container>
          <div class="detail_modal card text-left m-auto" style="overflow: scroll;max-width: 500px;">
            <div class="card-header text-left" style="background-color: #fff;">
              <span>レビュー詳細情報</span>
            </div>
            <div class="text-left mx-3 mt-3">
              <p>ユーザ: 
                <span>{{ modalDetail.nickname }} {{ get_hash_value(gender, modalDetail.gender) }} {{ modalDetail.old }}歳</span>
              </p>
              <template v-if="String(modalDetail.type) == '2'"> <!-- 販売者 -->
                <div class="d-flex">
                  <span class="mr-2">商品の満足度</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.product_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">掲載情報の正確性</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.infomation_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">スタッフの対応</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.staff_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">決済方法</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.payment_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">梱包</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.packing_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">配送</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.delivery_evaluation"></star-rating>
                </div>
              </template>
              <template v-if="String(modalDetail.type) == '1'"> <!-- ピアノ -->
                <div class="d-flex">
                  <span class="mr-2">響き・音色</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.tone_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">タッチ感</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.touch_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">つくりの良さ</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.made_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">デザイン</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.design_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">維持、管理のしやすさ</span>
                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="modalDetail.maintain_evaluation"></star-rating>
                </div>
                <div class="d-flex">
                  <span class="mr-2">このピアノを使う人</span>
                  {{ get_hash_value(who_use, modalDetail.who_use) }}
                </div>
                <div class="d-flex">
                  <span class="mr-2">このピアノの使い方</span>
                  {{ get_hash_value(how_use, modalDetail.how_use) }}
                </div>
              </template>
              <hr>
              <p>コメント: 
                <span v-html="convert_br(modalDetail.contents)"></span>
              </p>
              <template v-if="modalDetail.review_comment_contents != null && modalDetail.review_comment_contents != ''">
                <hr>
                <p>返答: 
                  <span v-html="convert_br(modalDetail.review_comment_contents)"></span>
                </p>
              </template>
            </div>
            <b-row class="mb-3">
              <b-col class="text-right px-4">
                <button id="detail_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="displayDetailModal=false">閉じる</button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>

  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'star-rating': StarRating,
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const gender = [
      {"no":"1","name":"男"},
      {"no":"2","name":"女"},
    ];
		const brand = [
      {"no":"1","name":"ヤマハ（YAMAHA）"},
      {"no":"2","name":"カワイ（KAWAI）"},
      {"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
      {"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
      {"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
      {"no":"6","name":"ボストン　（BOSTON）"},
      {"no":"7","name":"ディアパソン　（DIAPASON）"},
      {"no":"8","name":"アポロ　（APOLLO）"},
      {"no":"9","name":"国産ピアノ"},
      {"no":"10","name":"輸入ピアノ"},
    ];
		const who_use = [
      {"no":"1","name":"子供"},
			{"no":"2","name":"大人"},
			{"no":"3","name":"家族共用"},
			{"no":"4","name":"演奏家"},
			{"no":"5","name":"生徒"},
			{"no":"6","name":"不特定多数"},
			{"no":"7","name":"その他"},
		];
		const how_use = [
      {"no":"1","name":"普段用"},
			{"no":"2","name":"ピアノレッスン用"},
			{"no":"3","name":"サロン演奏用"},
			{"no":"4","name":"コンサートホールなど公共施設用"},
			{"no":"5","name":"その他"},
		];
    return {
      brand,
      gender,
      who_use,
      how_use,

      type: '',
      sort: 1,

      displayDetailModal: false,
      modalDetail: {
        type: null,
        // 販売者
        product_evaluation: null,
        infomation_evaluation: null,
        staff_evaluation: null,
        payment_evaluation: null,
        packing_evaluation: null,
        delivery_evaluation: null,
        // ピアノ
        tone_evaluation: null,
        touch_evaluation: null,
        made_evaluation: null,
        design_evaluation: null,
        maintain_evaluation: null,
        who_use: null,
        how_use: null,
        // 共通
        contents: null,
        old: null,
        // 返答
        review_comment_contents: null,
        // ユーザ
        gender: null,
        nickname: null,
      },

      displayReviewCommentModal: false,
      isError: false,
      reviewCommentForm: {
        errors: {
          contents: [],
        },
        contents: "",
        reviews_id: null,
      },

			all_reviews: [],
			all_parPage_review: 5,
			all_currentPage_review: 1,
    }
  },
	methods: {
    changeType: function(type){
      // 再検索
      this.type = type;
      this.all_reviews = [];
      this.get_review();
      return false;
    },
    changeSort: function(sort){
      // 再検索
      this.sort = sort;
      this.all_reviews = [];
      this.get_review();
      return false;
    },
		async get_review() {
			this.$store.dispatch('review/get_review', {
        type: this.type,
        sort: this.sort,
      }).then(res => {
				console.log(res);
				this.all_reviews = res.data.reviews;
				console.log(this.all_reviews);
				// this.productCount = this.all_reviews.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallbackReview: function (pageNum) {
      this.all_currentPage_review = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
    showModalDetail: function (review) {
      this.displayDetailModal = true;
      this.modalDetail.contents = review['review']['contents'];
      this.modalDetail.type = review['review']['type'];
      this.modalDetail.product_evaluation = review['review']['product_evaluation'];
      this.modalDetail.infomation_evaluation = review['review']['infomation_evaluation'];
      this.modalDetail.staff_evaluation = review['review']['staff_evaluation'];
      this.modalDetail.payment_evaluation = review['review']['payment_evaluation'];
      this.modalDetail.packing_evaluation = review['review']['packing_evaluation'];
      this.modalDetail.delivery_evaluation = review['review']['delivery_evaluation'];
      this.modalDetail.tone_evaluation = review['review']['tone_evaluation'];
      this.modalDetail.touch_evaluation = review['review']['touch_evaluation'];
      this.modalDetail.made_evaluation = review['review']['made_evaluation'];
      this.modalDetail.design_evaluation = review['review']['design_evaluation'];
      this.modalDetail.maintain_evaluation = review['review']['maintain_evaluation'];
      this.modalDetail.who_use = review['review']['who_use'];
      this.modalDetail.how_use = review['review']['how_use'];
      this.modalDetail.contents = review['review']['contents'];
      this.modalDetail.old = review['review']['old'];
      this.modalDetail.review_comment_contents = review['review_comment_contents'];
      this.modalDetail.gender = review['gender'];
      this.modalDetail.nickname = review['nickname'];
    },
    modalReviewComment: function (id) {
      this.displayReviewCommentModal = true;
      this.reviewCommentForm.reviews_id = id;
      this.reviewCommentForm.contents = "";
    },
    post_review_comment: function() {
			this.isError = false;
			this.reviewCommentForm.errors.contents = [];
			if (!this.reviewCommentForm.contents) {
				this.reviewCommentForm.errors.contents.push('返答内容が入力されていません');
				this.isError = true;
			}
			if (!this.isError) {
        this.post_review_comment_exec();
			// } else {
			// 	window.scrollTo({
			// 		top: 0,
			// 	});
			}
      return false;
    },
    async post_review_comment_exec() {
      this.$store.dispatch('review/post_review_comment', {
        reviewCommentForm: this.reviewCommentForm,
      }).then(res => {
        alert('返答が完了しました');
        this.displayReviewCommentModal = false;
        for (let i = 0; i < this.all_reviews.length; i++) {
          if ( String(this.all_reviews[i]['review']['id']) == String(this.reviewCommentForm.reviews_id) ) {
            this.all_reviews[i]['review_comment_comp'] = true;
            this.all_reviews[i]['review_comment_contents'] = this.reviewCommentForm.contents;
          }
        }
        this.reviewCommentForm.contents = "";
        this.reviewCommentForm.reviews_id = null;
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },


  },
	created() {
		this.get_review();
	},
	computed: {
		allGetReviews: function() {
			return this.all_reviews;
		},
		allGetPageCountReview: function() {
			return Math.ceil(this.all_reviews.length / this.all_parPage_review);
		},
	},
}
</script>

<style>
/* modal */
#overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

#overlay.review_comment,
#overlay.detail {
  z-index: 2000;
}

.review_comment_modal,
.detail_modal {
  margin-top: 6%!important;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 30rem!important;
  background-color: #FFFFFF;
  box-shadow: 1px 1px 12px 1px rgba(164, 164, 164, 0.25);
  border-radius: 16px;
  width: 88%;
}
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/review.vue